import { DOCUMENT } from '@angular/common';
import { Injectable, Optional, inject } from '@angular/core';

import { Observable, fromEvent } from 'rxjs';

import { SliderContainerDirective } from './slider-container.directive';

@Injectable()
export class SliderEventService {
    private readonly _doc = inject(DOCUMENT);

    constructor(@Optional() private container: SliderContainerDirective) {}

    get mousemove(): Observable<MouseEvent> {
        const container = this.container?.element.nativeElement || this._doc;

        return fromEvent<MouseEvent>(container, 'mousemove');
    }

    get mouseup(): Observable<MouseEvent> {
        return fromEvent<MouseEvent>(this._doc, 'mouseup');
    }
}
